import { io } from "socket.io-client";
import Cookies from "js-cookie";

// Stavi točnu adresu tvog backend servera (lokalno ili produkcija) https://project-wh-server.onrender.com http://localhost:4000
const socket = io("https://project-wh-server.onrender.com", {
    autoConnect: false,
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    timeout: 20000,
});

export const connectWithAuth = () => {
    socket.auth = {
        token: Cookies.get("gAuthToken") || Cookies.get("authToken"),
    };
    socket.connect();
};

export const disconnectSocket = () => {
    if (socket.connected) socket.disconnect();
};

export default socket;
